import React from 'react'
import { Box, Typography } from '@mui/material'
import { motion } from 'framer-motion'

const SEGMENTS = [
  { label: 'x0.5', color: '#ef5350' },
  { label: 'x1', color: '#42a5f5' },
  { label: 'x1.5', color: '#66bb6a' },
  { label: 'x2', color: '#ffa726' },
  { label: 'x2.5', color: '#ab47bc' },
  { label: 'x3', color: '#ffd700' },
]

export default function BonusWheel({ spinning, result }) {
  const rotation = spinning ? 1440 + (result ? SEGMENTS.findIndex(s => parseFloat(s.label.slice(1)) === result) * 60 : 0) : 0

  return (
    <Box sx={{ textAlign: 'center', py: 4 }}>
      <Typography variant="h4" gutterBottom>🎡 Roue Bonus</Typography>
      <Box sx={{ position: 'relative', width: 280, height: 280, mx: 'auto', my: 3 }}>
        <motion.div
          animate={{ rotate: rotation }}
          transition={{ duration: 4, ease: [0.2, 0.8, 0.2, 1] }}
          style={{
            width: 280,
            height: 280,
            borderRadius: '50%',
            background: `conic-gradient(${SEGMENTS.map((s, i) => `${s.color} ${i * 60}deg ${(i + 1) * 60}deg`).join(', ')})`,
            border: '6px solid #333',
            boxShadow: '0 0 30px rgba(255,215,0,0.5)'
          }}
        />
        <Box sx={{
          position: 'absolute', top: -10, left: '50%', transform: 'translateX(-50%)',
          width: 0, height: 0,
          borderLeft: '12px solid transparent',
          borderRight: '12px solid transparent',
          borderTop: '24px solid #333'
        }} />
      </Box>
      {result && !spinning && (
        <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }}>
          <Typography variant="h3" color="warning.main">Multiplicateur x{result} !</Typography>
        </motion.div>
      )}
    </Box>
  )
}
